import React, { useState, useEffect } from 'react';
import { scrollToTop } from '../utils/scrollUtils';
import '../assets/styles/ScrollToTop.css';

const ScrollToTop = ({ showBelow = 300 }) => {
  const [show, setShow] = useState(false);
  
  const handleScroll = () => {
    if (window.pageYOffset > showBelow) {
      if (!show) setShow(true);
    } else {
      if (show) setShow(false);
    }
  };

  // Add scroll event listener
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [show, showBelow]);

  // Handle click event
  const handleClick = () => {
    scrollToTop()();
  };

  return (
    <button
      className={`scroll-to-top ${show ? 'visible' : ''}`}
      onClick={handleClick}
      aria-label="Scroll to top"
      title="Scroll to top"
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      >
        <polyline points="18 15 12 9 6 15"></polyline>
      </svg>
    </button>
  );
};

export default ScrollToTop;